import { createContext, useState, useEffect } from "react";
import api from "../common/api";

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    return "default";// replace here the color name like -> red, teal, green , default
  });

  //  apply theme
  useEffect(() => {
    api.get("/tenant/metadata").then((response) => {
      const userTheme = response.data.metadata.color || "default";
      setTheme(userTheme);
      if (response.data.metadata.color === "default") {
      document.documentElement.removeAttribute("data-theme");
    } else {
      document.documentElement.setAttribute("data-theme", response.data.metadata.color);
    }

    localStorage.setItem("theme", theme);
    }).catch((error) => {
      console.error("Error fetching theme:", error);
    });
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};